import { render } from "./downloadBoxVideo.vue?vue&type=template&id=5c8a1f9a&scoped=true"
import script from "./downloadBoxVideo.vue?vue&type=script&lang=js"
export * from "./downloadBoxVideo.vue?vue&type=script&lang=js"

import "./downloadBoxVideo.vue?vue&type=style&index=0&id=5c8a1f9a&lang=scss&scoped=true"

import exportComponent from "/Users/carolinehansen/Sites/work-manyone/koebenhavns-kommune/bygdrift/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5c8a1f9a"]])

export default __exports__